<template>
  <div class="bill-tick-view">
    <BillTick />
  </div>
</template>

<script>
import BillTick from '@/components/bill/BillTick.vue'

export default {
  name: 'BillTickView',
  components: {
    BillTick
  }
}
</script>

<style scoped>
.bill-tick-view {
  flex: 1;
}
</style>
